import { TFunction } from '@gem/modules/i18n';

import { GroupType } from 'APP/model/group/groupModel.types';

import {
  TSystemMessageTextHandler,
  ISystemMessageText,
  ISystemMessageTextPresenter,
} from '../useSystemMessageText.types';

const getGroupTypeChanged: TSystemMessageTextHandler = (
  presenter: ISystemMessageTextPresenter,
  t: TFunction
): ISystemMessageText => {
  const stringKey =
    presenter.newType === GroupType.Open
      ? 'system_message_group_is_public'
      : 'system_message_group_is_private';

  return {
    html: t(stringKey, {
      0: `<span class="system-message-title">${presenter.initiatorDisplayName}</span>`,
      interpolation: { escapeValue: false },
    }),
    sourceText: t(stringKey),
    params: {
      '{0}': { text: presenter.initiatorDisplayName, userId: presenter.initiator?.id },
    },
  };
};

const getChannelTypeChanged: TSystemMessageTextHandler = (
  presenter: ISystemMessageTextPresenter,
  t: TFunction
): ISystemMessageText => {
  const channelKey =
    presenter.newType === GroupType.ChannelOpen
      ? 'system_message_channel_is_public'
      : 'system_message_channel_is_private';

  const adminText = t('common_admin');

  const text = t(channelKey, {
    0: adminText,
    interpolation: { escapeValue: false },
  });

  return { html: text, sourceText: t(channelKey) };
};

export const chatTypeChangedHandler: TSystemMessageTextHandler = (
  presenter: ISystemMessageTextPresenter,
  t: TFunction
): ISystemMessageText => {
  if (presenter.isChannel) {
    return getChannelTypeChanged(presenter, t);
  }

  return getGroupTypeChanged(presenter, t);
};
